import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  SimpleList,
} from "react-admin";

export const EtapasGrandesGeneradoresFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
    </Filter>
  )
}

export const EtapasGrandesGeneradoresEdit = props => (
  <Edit title="Editar etapa" {...props}>
    <SimpleForm redirect="/etapas-grandes-generadores">
      <TextInput label="Nombre de Etapa" source="nombre" />
    </SimpleForm>
  </Edit>
);

export const EtapasGrandesGeneradoresCreate = props => (
  <Create {...props} title="Incorporar Etapa">
    <SimpleForm redirect="/etapas-grandes-generadores">
      <TextInput label="Nombre de Etapa" source="nombre" />
    </SimpleForm>
  </Create>
);

export const EtapasGrandesGeneradoresList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<EtapasGrandesGeneradoresFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
        />
      }
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/etapasGrandesGeneradores.js